/* Loja do Chico — interações leves.
   1) Seletor de cor de filamento: mostra o nome da cor escolhida (sempre ativo).
   2) Reveal on scroll: à prova de falha, só esconde quando este script roda
      (classe .chico-anim no <html>) e respeita prefers-reduced-motion. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---- 1) Cor do filamento ----
  function filamentInit(scope) {
    (scope || document).querySelectorAll('[data-chico-filament]').forEach(function (w) {
      var cur = w.querySelector('[data-filament-current]');
      function upd() {
        var c = w.querySelector('input:checked');
        if (cur && c) cur.textContent = '· ' + c.value;
      }
      if (!w.__chicoBound) { w.addEventListener('change', upd); w.__chicoBound = true; }
      upd();
    });
  }
  onReady(function () { filamentInit(); });
  document.addEventListener('shopify:section:load', function (e) { filamentInit(e.target || document); });

  // ---- 2) Reveal on scroll ----
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var root = document.documentElement;
  root.classList.add('chico-anim');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function observe() {
    document.querySelectorAll('.chico-reveal:not(.is-visible)').forEach(function (el) { io.observe(el); });
  }
  onReady(observe);
  document.addEventListener('shopify:section:load', function () { root.classList.add('chico-anim'); observe(); });
  window.addEventListener('pageshow', observe);

  // Rede de segurança: revela o que estiver visível após 1.5s
  setTimeout(function () {
    document.querySelectorAll('.chico-reveal:not(.is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-visible');
    });
  }, 1500);
})();
